import { defineMessages } from 'react-intl-next';
var messages = defineMessages({
  browseWithDropzone: {
    id: 'jsm.attachment-field.browse-with-dropzone',
    defaultMessage: 'Drop files to attach or<a>browse</a>',
    description: 'dropzone for drag and drop or browse file explorer link'
  },
  missingToken: {
    id: 'jsm.attachment-field.missing-token',
    defaultMessage: 'Something went wrong',
    description: 'Error message when token is missing'
  }
});
export default messages;